import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';
import { initSentry } from './app/core/observability/sentry.init';

initSentry({ dsn: environment.sentryDsn, environment: environment.envName });

bootstrapApplication(AppComponent, appConfig).catch((err) => {
  console.error(err);
});
